import { render, staticRenderFns } from "./NoMoneyBalanceModal.vue?vue&type=template&id=8643ceb6&"
import script from "./NoMoneyBalanceModal.vue?vue&type=script&lang=js&"
export * from "./NoMoneyBalanceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports